import { hasPermission } from "@/lib/employeePermissions";

import useAuthStore from "@/stores/useAuthStore";

const CheckRole = ({ children, section, action }) => {
  const user = useAuthStore((state) => state.user);
  // action is either VIEW or EDIT
  // section is a MerchantUserRoleKey: PRODUCTS, CLIENTS, ACTIVATIONS, CLAIMS,
  // CAMPAIGNS, APPS, DOCUMENTS, PERSONALS ve bunların alt kırılımları
  // (ör. PRODUCTS_INTEGRATIONS, ACTIVATIONS_SALES)

  // example of roles array
  //   {
  //     "PRODUCTS": [
  //         "VIEW",
  //         "EDIT"
  //     ],
  //     "PRODUCTS_INTEGRATIONS": [
  //         "VIEW"
  //     ],
  //     "ACTIVATIONS": [
  //         "VIEW",
  //         "EDIT"
  //     ],
  //     ...
  // }

  return hasPermission(user?.roles, section, action) ? children : null;
};

export default CheckRole;
